module.exports = __webpack_public_path__ + "assets/img/4.18a4ef55.png";